import * as Models from '../commonModels';
import { GaragePreviewModel } from '../garage/garage';
import { MechanicPreviewModel } from '../mechanic/mechanic';
import * as OrderModels from '../order/order';
import * as DepositeModels from '../deposite/deposite';
import * as TyreStateModels from '../tyre/tyreState';
import * as CarModels from '../car/car';
import * as ServiceModels from '../services/service';
import * as CustomerModels from '../customer/customer';
import * as ContractModels from '../contract/contract';

export class SpecificationListModel extends Models.ListBaseModelWithAdditonalReturnInformation {
  Items: SpecificationModel[];

  constructor(Items?: SpecificationModel[], RequestSignature?: number, PageCount?: number, CurrentPage?: number, TotalItems?: number) {
    super();
    this.Items = Items || new Array();
    this.Success = true;
    this.TotalItems = TotalItems;
    this.IsCarExist = false;
    this.RequestSignature = RequestSignature;
    this.PageCount = PageCount;
    this.CurrentPage = CurrentPage;
  }
}

export class SpecificationModel {
  constructor() {
    this.Hide = false;
  }
  public SpecificationId: number;
  public Number: string;
  public IteratorNumber: number;
  public MeterReading: number | null;
  public Driver: string;
  public AuthorizationText: string;
  public IsAfterSaleFixed: boolean;
  public AfterSaleValue: number;
  public SpecificationStatusId: number;
  public MeetDate: string | null;
  public Customer: string;
  public CustomerId: number;
  public ContractId: number;
  public CarId: number;
  public RegistrationNumber: string;
  public GarageId: number;
  public InvoiceId: number | null;
  public GarageInvoiceId: number | null;
  public Invoice: string | null;
  public GarageInvoice: string | null;
  public SummerPriceListId: number | null;
  public WinterPriceListId: number | null;
  public AddedWaitingVersionByUserId: number | null;
  public AddWaitinglVersionDate: string | null;
  public AddedByUserId: number;
  public AddDate: string;
  public FinalDate: string;
  public AddedByUser: string;
  public DeletedByUserId: number | null;
  public DeletedDate: string | null;
  public DeleteByUser: string;
  public UpdatedByUserId: number | null;
  public UpdatedDate: string | null;
  public UpdatedByUser: string;
  public Import: number | null;
  public TyreOfferId: number | null;
  public CourierId: number | null;
  public ShipmentNumber: string;
  public IsMechanical: boolean;
  public WaitForConfirmationTo: string | null;
  public LinkedSaleSpecification: number | null;
  public IsWillBeOrWasConfirmed: boolean;
  public Mark: string;
  public SourceSpecification: number | null;
  public File1: string;
  public File2: string;
  public GarageValue: number;
  public CustomerValue: number;
  public GarageArticlesValue: number;
  public GarageServicesValue: number;
  public CustomerArticlesValue: number;
  public GustomerServicesValue: number;
  //public DepositeId: number;
  public IsModified: boolean;
  public Profit: number;
  public ProfitNetNet: number;
  public CustomerServicesValue: number;
  public Garage: GaragePreviewModel;
  public Car: CarModels.CarModel;
  public Mechanic: MechanicPreviewModel[];
  public Hide: boolean;

  public TyreCount: number;

  public CustomerPreview: CustomerModels.CustomerPreviewModel;

  public Order: OrderModels.OrderPreviewModel;

  public SpecificationDetails: SpecificationDetailsModel[];

  public Deposites: DepositeModels.DepositePreviewModel[];

  public CurrentTyreSates: TyreStateModels.TyreStatePreviewModel[];

  public Contract: ContractModels.ContractModel;

  //Zmienna pomocnicza dla UI informująca czy zestaw opon zamontowanych posiada jakiekolwiek informacje o oponach czy też jest czystym templatem.
  public IsCurrentTyreSatesValid: boolean;

  public IsFinalStatus: boolean;

  public IsWaitingToAcceptedStatus: boolean;

  public IsWaitingStatus: boolean;

  public Status: string;

  //Czy akcja zapisu lub utworzenia specyfikacji ma skutkować ustawieniem statusu final.
  public SetFinalStatus: boolean;

  public SpecificationLogs: SpecificationLogModel[];

  //Zmienne pomocnicze - nie sa serializowane - do użycia tylko na UI
  public IsReadOnly: boolean;

  public IsShowServicePrice: boolean;

  public IsShowCustomerPrice: boolean;

  public CanceSpecification: boolean;

  public InPreparation: boolean;

  public CanceSpecificationAndCreateNew: boolean;

  public NoteCount: number;
}


export class SpecificationPreviewModel {
  public SpecificationId: number;
  public Number: string;
  public SpecificationStatusId: number;
  public IsWaiting: boolean;
  public Status: string;
  public AddDate: Date;
  public GarageId: number;
  public Garage: string;
  public NoteCount: number;
}

export class SpecificationListSummaryModel extends Models.ResponseBase {
  GarageServiceSum: number;
  PartnerGarageServiceSum: number;
  GarageArticleSum: number;
  GarageArticleAfterSaleSum: number;
  PartnerGarageArticleSum: number;
  CustomerServiceSum: number;
  PartnerCustomerServiceSum: number;
  CustomerArtictleSum: number;
  PartnerCustomerArtictleSum: number;
  AfterSaleSum: number;
  PartnerAfterSaleSum: number;

  constructor() {
    super();
    this.GarageServiceSum = 0;
    this.PartnerGarageServiceSum = 0;
    this.GarageArticleSum = 0;
    this.GarageArticleAfterSaleSum = 0;
    this.PartnerGarageArticleSum = 0;
    this.CustomerServiceSum = 0;
    this.PartnerCustomerServiceSum = 0;
    this.CustomerArtictleSum = 0;
    this.PartnerCustomerArtictleSum = 0;
    this.AfterSaleSum = 0;
    this.PartnerAfterSaleSum = 0;
  }

}

export enum WorkMode {
  ListMode = 0,
  NewGarageInvoiceMode = 1,
  NewCustomerInvoiceMode = 2,
  NewCustomerInvoiceCorrectMode = 3,
  EditCustomerInvoiceMode = 4,
}


export class CustomerInvoiceModel extends Models.ResponseBase {
  CustomerId: number;
  PaymentDays: number;
  SegregateBy: number;
  Mark: string;
  IssueDate: boolean;
  IsMechanical: boolean;
  Notes: string;

}

export class SpecificationDetailsModel {
  public SpecificationDetailId: number;
  public SpecificationId: number;
  public Note: string;
  public TyreId: number;
  public Tyre: string;
  public ArticleId: number;
  public Count: number;
  public GaragePrice: number;
  public GarageAfterSaleValue: number;
  public CustomerPrice: number;
  public AfterSaleValue: number;
  public ExtraFeeForRelocationId: number;
  public DepositeId: number;
  public OrderId: number;
  public IsUtilizationArchived: boolean;
  public AddedByUserId: number;
  public AddDate: Date;
  public DeletedByUserId: number;
  public DeleteDate: Date;
  public UpdatedByUserId: number;
  public UpdateDate: Date;
  public Import: number;
  public AuthorizationText: string;
  public CostEstimationId: number;
  public AdditionalOptions: string;
  public Mark: string;
  public ServiceTypeId: number;
  public IsSaleService: boolean;
  public IsDefinePrice: boolean;
  public IsEnableManualChangeCount: boolean;
  public IsNeedAuthorizationField: boolean;

  public IsArticleRelation: boolean;
  public GarageDepositeNumber: string;

  public TyreStatesPreviews: TyreStateModels.TyreStatePreviewModel[];
  public Deposite: DepositeModels.DepositePreviewModel;
  public Service: ServiceModels.ServiceModel;


  public IsDOTRequired: boolean;
  //Zmienna pomocnicza - tylo po stronie UI
  public IsValid: boolean;

  //Zmienna pomocnicza - tylo po stronie UI - czy nalezy pokazac kontrolke input zamiast combo
  public IsCountOpenGap: boolean;

  //Zmienna pomocnicza - tylo po stronie UI - czy modyfikowana  była cena dla klienta - potrzebne do przeliczania ceny garażu dla usług bez definicji ceny.
  public IsCustomerPriceChanges: boolean;


  public IsEnableManualGaragePrice: boolean;

  public IsEnableManualCustomerPrice: boolean;

  //Czy można edytować numer depozytu
  public IsEnableManualGarageDepositeNumber: boolean;

  //Czy powinien pokazać się podgląd depozytu
  public IsEnableDepositeEdit: boolean;

  //Czy powinien pokazać sie podgląd zestawu opon
  public IsEnableTyreStatesEdit: boolean;

  public IsShowCustomerPrice: boolean;

  public IsRim: boolean;

  public IsNoteAvailable: boolean;

  public SpecificationDetailStatusId: number;

  public IsAcceptedStatus: boolean;

  public IsWaitingToAcceptedStatus: boolean;

  public IsRejectedStatus: boolean;
}

export class SpecificationLogModel {
  public SpecificationLogId: number;
  public SpecificationId: number;
  public SpecificationDetailId: number;
  public TyreStateId: number;
  public PropertyName: string;
  public Action: string;
  public OldValue: string;
  public NewValue: string;
  public AddedByUserId: number;
  public AddDate: Date;
  public IsDenyForGarage: boolean;
  public IsDenyForCustomer: boolean;
  public AddedByUser: string;
}

export class SpecyficationReportModel {
  public SpecificationId: number;
  public Mode: number; 
  // Mode
  // WithoutPrices =0,
  // ClientPrices =1,
  // AllPrices =2,
}

export class SpecificationDetailNoteModel {
  public SpecificationDetailNoteId: number;
  public SpecificationDetailId: number;
  public Text: string;
  public AddByUserId: number;
  public AddDate: Date;
  public AddByUser: string;
  public IsSystemNote: boolean;
}

export class SpecificationNoteModel {
  public SpecificationNoteId: number;
  public SpecificationId: number;
  public Text: string;
  public AddByUserId: number;
  public AddDate: Date;
  public AddByUser: string;
  public IsSystemNote: boolean;
}

export enum SpecificationDetailStatuType {
  Accepted = 1,
  WaitingToAccepted = 2,
  Rejected = 3
}

export enum SpecificationStatuType {
  Waiting = 1,
  Final = 2,
  WaitingToAccepted = 3
}
